<template>

  <section class="text-white py-12 min-h-screen">
    <div class="container mx-auto text-center">
      <h1 class="sr-only">Our Trusted Business Partners</h1>
      <h2 class="text-4xl lg:text-7xl font-bold text-[#e4ac3b] uppercase tracking-wide drop-shadow-[2px_2px_5px_rgba(228,172,59,0.7)]">
        Partners
      </h2>

      <div class="w-80 mx-auto border-t border-[#e4ac3b] my-3"></div>

      <section class="mt-8 flex justify-center">
        <article>
          <a 
            href="https://www.linkedin.com/company/money-trees/" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Explore Money Trees on LinkedIn"
          >
            <div class="partner-card">
              <img src="../assets/images/mt.webp" alt="Money Trees Logo" class="partnerimage transition-transform duration-300 ease-in-out group-hover:scale-105" loading="lazy">
            </div>
          </a>
        </article>
      </section>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const isHidden = ref(false);
let lastScrollY = window.scrollY;

const links = ref([
  { text: "Home", path: "/" },
  { text: "About", path: "/about" },
  { text: "Products", path: "/products" },
  { text: "Partners", path: "/partners" },
]);

const handleScroll = () => {
  const currentScrollY = window.scrollY;
  isHidden.value = currentScrollY > lastScrollY && currentScrollY > 50;
  lastScrollY = currentScrollY;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.transition-transform {
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.partner-card {
  background-color: #111111;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;
}

.partner-card:hover {
  box-shadow: 0 0 20px rgba(228, 125, 57, 0.8), 0 0 25px rgba(255, 159, 69, 0.7);
  transform: scale(1.05);
}

.partnerimage {
  transition: all 0.3s ease-in-out;
}

.partner-card:hover .partnerimage {
  filter: drop-shadow(0 0 10px #e4ac3b);
}

.partner-card:active {
  transform: scale(0.95);
}

@media (max-width: 991px) {
  .partner-card {
    width: 75%;
    margin: auto;
  }
}

@media (max-width: 480px) {
  .partner-card {
    width: 70%;
    margin: auto;
  }
}
</style>
